<template>
  <div class="index">
    <header-menu></header-menu>
    <router-view />
    <footer-menu></footer-menu>
  </div>
</template>

<script>
import HeaderMenu from "@/components/HeaderMenu.vue";
// import MainContent from "./components/MainContent.vue";
import FooterMenu from "@/components/FooterMenu.vue";

export default {
  name: "Index",
  components: { HeaderMenu, FooterMenu },
};
</script>
